import type { FlagConfiguration } from '@atlassian/jira-flags';
import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	title: {
		id: 'copy-filters-modal.common.flags.success.title',
		defaultMessage: 'A copy of {name} was successfully created.',
		description:
			'Flag title. Flag is shown in Subscription modal when the request to create a copy of filter has succeeded',
	},
});

const copyFilterSuccessFlag = (name: string): FlagConfiguration => ({
	type: 'success',
	title: [messages.title, { name }],
	isAutoDismiss: true,
	messageId: 'copy-filters-modal.common.ui.flags.success',
	messageType: 'transactional',
});

export default copyFilterSuccessFlag;
